/**
 * Бейдж тира (§2.3 «<TierBadge>», §13).
 *
 * Значения приходят кодами справочника `tier`: 'A+' | 'A' | 'B' | 'C'
 * (db/migrations/002_seed.sql). Неизвестный код не прячется и не падает —
 * показывается как есть серой плашкой: справочник расширяемый (§9.2).
 *
 * Пустое значение — не «нет бейджа», а бейдж пустого значения: пунктирная
 * рамка и «—». Главная операция системы — засыпка тиров (206 брендов без
 * тира), и дырка должна быть видна как задача (П3, §0).
 */
import './TierBadge.css'

export type TierCode = 'A+' | 'A' | 'B' | 'C'

export interface TierBadgeProps {
  /** Код справочника или null/undefined — «не задано». */
  tier?: string | null
  /** Доступная подпись пустого значения. */
  emptyLabel?: string
  className?: string
}

const TIER_CLASS: Record<string, string> = {
  'A+': 'tier-badge--ap',
  A: 'tier-badge--a',
  B: 'tier-badge--b',
  C: 'tier-badge--c',
}

export function TierBadge({ tier, emptyLabel = 'тир не задан', className }: TierBadgeProps) {
  const empty = tier == null || tier === ''
  const classes = ['tier-badge', 't-badge']
  classes.push(empty ? 'tier-badge--empty' : (TIER_CLASS[tier] ?? 'tier-badge--b'))
  if (className) classes.push(className)

  return (
    <span className={classes.join(' ')}>
      {/* Подпись для скринридера: «A+» без контекста читается как мусор. */}
      <span className="visually-hidden">{empty ? emptyLabel : `тир ${tier}`}</span>
      <span aria-hidden="true">{empty ? '—' : tier}</span>
    </span>
  )
}
